import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Tab from './Tab/Tab';
/* import TabContainer from "./TabContainer/TabContainer"; */

class Tabs extends Component {
  static propTypes = {
    children: PropTypes.instanceOf(Array).isRequired
  };

  constructor(props) {
    super(props);

    var tabPos = this.props.children
      .map(function(x) {
        return x.props.show;
      })
      .indexOf(1);
    var tabIndex = tabPos;

    this.state = {
      activeTab: this.props.children[tabIndex].props.label,
      metrics: this.props.metrics
    };
  }

  onClickTabItem = tab => {
    this.setState({ activeTab: tab });
  };

  render() {
    const {
      onClickTabItem,
      props: { children },
      state: { activeTab }
    } = this;

    return (
      <div className="tabs">
        <ul className="lui-tabset lui-tabset--fill">
          {children.map(child => {
            const { label } = child.props;
            if(child.props.show === 1) {
            return (
              <Tab
                activeTab={activeTab}
                key={Math.random()}
                label={label}
                onClick={onClickTabItem}
              />
            )}
          })}
        </ul>
        <div className="tab-content">
          {children.map(child => {
            if (child.props.label !== activeTab) return undefined;
            return child.props.children;
          })}
        </div>
      </div>
    );
  }
}

export default Tabs;
